var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showTip)?_c('span',[_vm._v(_vm._s(_vm.text))]):[_c('el-tooltip',{attrs:{"content":_vm.text,"popper-class":"tip-max","effect":"dark","placement":"top"}},[_c('span',[_vm._v(_vm._s(_vm.tip))])])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }